import {EspotoQREvaluator, EspotoQRType} from './espoto-qr-evaluator.mjs';

/**
 * Shared handling of scanned QR codes and PIN results (login form, event selection card,
 * event list). Host components must also use layoutMixin and settingsMixin.
 */
export var qrJoinMixin = {
    methods: {
        // the login and event list routes need both the QR data and the event id
        isScannedCodeValid(data) {
            const qrEvaluator = new EspotoQREvaluator(data, this);
            return qrEvaluator.isValid() && !!qrEvaluator.getEventId();
        },
        /**
         * Event and task QRs need a login and are read on the event list; demo-user and account QRs
         * go through the login page (guest registration / qrlogin). Returns a locale key when the
         * code could not be used, otherwise null.
         */
        handleScannedQr(qrData) {
            const qrEvaluator = new EspotoQREvaluator(qrData, this);
            switch (qrEvaluator.espotoQRType) {
                case EspotoQRType.EventQR:
                case EspotoQRType.TaskQR:
                    if (!this.isLoggedIn) {
                        return 'errorCodeNeedLogin';
                    }
                    this.goToEventList({ d: qrEvaluator.basicQR, e: qrEvaluator.eventId });
                    return null;
                case EspotoQRType.EventDemoUserQR:
                case EspotoQRType.EventAccountQR:
                    this.goToLogin({ d: qrEvaluator.basicQR, e: qrEvaluator.eventId }, true);
                    return null;
                default:
                    return null;
            }
        }
    }
};
